import { AxiosResponse } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient } from "../../helpers/apiClient";
import {scheduleUrl} from "../../helpers/apiURL";
import {
  Response,
  ScheduleType,
} from "./types";

export const getScheduleCalenderList = createAsyncThunk(
  "schedule/getScheduleCalenderList",
  async (payload: {
    date: string;
    mode: string;
  }) => {
    return await axiosClient
      .get<Response<ScheduleType[]>>(
        scheduleUrl +
          "/" +
          payload.date +
          "?mode=" +
          payload.mode,
      )
      .then(
        (response: AxiosResponse<Response<ScheduleType[]>>) => response.data,
      )
      .then((d: Response<ScheduleType[]>) => d.data)
      .catch((err) => {
        throw err;
      });
  },
);
